import { AutocompleteAdapter } from 'components/enhanced/form/adapters/selects/AutocompleteAdapter';
import EnhancedForm from 'components/enhanced/form/EnhancedForm';
import { IdentityField } from 'components/enhanced/form/fields/IdentityField';
import { required } from 'components/helpers/validators';
import dayjs from 'dayjs';
import { transportDocumentService } from 'features/inventory/transport-documents/TransportDocument/api/transport-document.service';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Option } from 'shared/types/general';

interface TranportDocumentFormProps {
  onSubmit: (data: any) => void;
  supplierId: number;
}

export const TranportDocumentForm = ({ onSubmit, supplierId }: TranportDocumentFormProps) => {
  const { t } = useTranslation();

  const [options, setOptions] = useState<Option[]>([]);

  useEffect(() => {
    if (supplierId) {
      transportDocumentService.getUnassigned(10000, 0, { supplier_id: supplierId }).then((res) => {
        setOptions(
          res.results.map((ddt) => {
            return {
              id: ddt.id,
              code: `N. ${ddt.ref} ${
                ddt.date ? '(' + dayjs(ddt.date).format('DD/MM/YYYY') + ')' : ''
              }`
            };
          })
        );
      });
    } else {
      setOptions([]);
    }
  }, [supplierId]);

  return (
    <EnhancedForm onSubmit={onSubmit} formId="newInvoice" hideControls>
      <IdentityField
        name="transport_document"
        component={AutocompleteAdapter}
        options={options}
        label={t('pages.invoices.update.transport-document')}
        validate={required}
        required
      />
    </EnhancedForm>
  );
};

export default TranportDocumentForm;
